<template>
    <div class="new_detail_page">
        <b-container>

            <b-breadcrumb :items="items"></b-breadcrumb>

            <div class="detail">
                <h1 class="title clamp2">{{ informationInfo.name }}</h1>

                <p class="time">{{ informationInfo.createTime }}</p>

                <div class="content" v-html="informationInfo.content"></div>
            </div>


            <div class="other">
<!--                <p class="title"></p>-->

                <b-row style="margin-top: 50px">
                    <div class="clearfix">
                        <div class="video_box left" style="margin-right: 25px"
                             v-for="item in informationList" :key="item.id" v-if="item.id !=informationInfo.id"
                             @click="$router.push('/news/about/detail?id='+item.id)">

                            <div class="img_box" style="height: auto">
                                <img :src="api + item.thumbnailFile">
                            </div>

                            <div class="info clearfix">
                                <span class="label" v-if="item.label">{{ item.label }}</span>
                                <div class="right">
                                    <span class="text">MORE</span>
                                </div>
                            </div>

                            <p style="width: 100%" class="video_title clamp1">{{ item.name }}</p>

                            <p class="time">{{ item.updateTime || item.createTime }}</p>
                        </div>
                    </div>
                </b-row>
            </div>
        </b-container>

    </div>
</template>

<script>
    import {api} from "@/api/api";
    import {getInformation} from "@/api/HomeService";

    export default {
        name: "NewDetail",
        data() {
            return {
                items: [
                    {
                        text: 'Admin',
                        href: '#'
                    },
                    {
                        text: '',
                        href: '#'
                    },
                    {
                        text: '',
                        active: true
                    }
                ],
                languageNum: window.localStorage.getItem("languageNum"),
                informationList: [],
                informationInfo: {},
                api: api,
                curItemId: "",
            }
        },
        methods: {
            newsHover(item, status) {
                this.curItemId = status ? item.id : '';
            },
            getInformationList() {
                let sendData = {
                    languageNum: this.languageNum,
                    type: 1
                }

                getInformation(sendData, data => {
                    console.log(data);
                    for (let i = 0; i < data.length; i++) {
                        console.log(this.informationList.length < 3 && data[i].id != this.informationInfo.id)
                        if (this.informationList.length < 3 && data[i].id != this.informationInfo.id) {
                            this.informationList.push(data[i])
                        }
                    }
                })
            },

            getInformationInfo() {
                let sendData = {
                    languageNum: this.languageNum,
                    type: 1,
                    id: this.$route.query.id
                }

                getInformation(sendData, data => {
                    this.informationInfo = data[0] || {}
                    this.informationInfo.createTime = this.informationInfo.createTime.split(" ")[0]
                    console.log(data)
                })
            },
        },
        mounted() {
            this.getInformationInfo()
            this.getInformationList()

            let lang;
            if (this.languageNum == 1) {
                lang = '/en';
            } else if (this.languageNum == 2) {
                lang = '/en-us';
            } else if (this.languageNum == 3) {
                lang = '/zh-hans';
            } else if (this.languageNum == 4) {
                lang = '/zh-hant';
            } else if (this.languageNum == 5) {
                lang = '/de';
            } else if (this.languageNum == 6) {
                lang = '/fr';
            } else if (this.languageNum == 7) {
                lang = '/it';
            } else if (this.languageNum == 7) {
                lang = '/es';
            }

            let menuList = JSON.parse(window.localStorage.getItem('menuList'));
            for (let i = 0; i < menuList.length; i++) {
                if (menuList[i].menuUrl === '/') {
                    this.items[0].text = menuList[i].menuNam;
                    this.items[0].href = '/#/' + lang
                }

                if (menuList[i].children) {
                    for (let j = 0; j < menuList[i].children.length; j++) {
                        if (menuList[i].children[j].menuUrl.indexOf('/news') > 0) {
                            this.items[1].text = menuList[i].children[j].menuNam
                            this.items[1].href = "/#" + lang + menuList[i].children[j].menuUrl
                        }
                    }
                }
            }

        }
    }
</script>

<style scoped lang="scss" src="../css/newsDetail.scss">

</style>